import { defineComponent as _defineComponent } from 'vue'

export enum OzListRowSeparator {
  None = 'none',
  Short = 'short',
  Long = 'long',
  FullWidth = 'full-width',
}

export { OzBaseButtonHrefMode as OzListRowHrefMode } from '@@/library/v4/components/OzBaseButton.vue'
const __default__ = {}

import OzBaseButton, { OzBaseButtonHrefMode } from '@@/library/v4/components/OzBaseButton.vue'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'OzListRow',
  props: {
    separator: { default: OzListRowSeparator.Short },
    darkMode: { type: [Boolean, String], default: 'auto' },
    clickable: { type: Boolean, default: true },
    href: { default: undefined },
    hrefMode: { default: OzBaseButtonHrefMode.Default }
  },
  emits: ['click'],
  setup(__props: any) {

const props = __props as { separator: OzListRowSeparator, darkMode: boolean | 'auto', clickable: boolean, href: string, hrefMode: OzBaseButtonHrefMode }





const xSeparator = computed((): boolean => props.separator !== 'none')

const lineSeparatorClass = computed((): Record<string, boolean> => {
  const colorClasses = {
    'after:bg-divider-gray dark:after:bg-divider-gray-dark': props.darkMode === 'auto',
    'after:bg-divider-gray': props.darkMode === false,
    'after:bg-divider-gray-dark': props.darkMode === true,
  }
  return {
    "after:content-['']": true,
    'after:absolute': true,
    'after:h-px': true,
    'after:bottom-[-4px]': true,
    ...colorClasses,
  }
})

return { __sfc: true,OzListRowSeparator, props, xSeparator, lineSeparatorClass, OzBaseButton }
}

})